module.exports = __webpack_public_path__ + "img/lessons.77199f93.png";